/* Auto generated by gulp-typescript-template */

export const Image = `<div class="Image content-margin"> <img view="Image" data="[[ image ]]" class="image [[ image ? '' : '-hidden' ]] image-responsive" alt="[[caption]]" title="[[caption]]"><div class="caption">[[ caption ]]</div></div>`;
